import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../utils/helpers';

const mutation = graphql`
  mutation RemoveSolicitationCommentMutation($input: RemoveSolicitationCommentInput!) {
    removeSolicitationComment(input: $input) {
      isUpdated
      solicitation {
        state
        comments {
          edges {
            node {
              id
              content
              contentEditedAt
              created
              repliedTo {
                user {
                  fullName
                }
                content
                created
              }
              contractor {
                fullName
                representativeImageUrl
                freelancer {
                  user {
                    id
                  }
                }
              }
              createdByStaff {
                fullName
                representativeImageUrl
                user {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

const RemoveSolicitationCommentMutation = (commentId, callback) => {
  const config = {
    mutation,
    variables: { input: { commentId } },
    onCompleted: response => {
      callback(response.removeSolicitationComment);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default RemoveSolicitationCommentMutation;
